module.exports = __webpack_public_path__ + "img/图层 22.46459b01.png";